import type { CapabilityId } from '@dale/plans';

import { accessTo } from '../components/shell/navAccess';
import { useBusiness } from './useBusiness';
import { useFeatures } from './useFeatures';

/**
 * Whether the business can use one section of the plan catalog right now:
 * its plan includes it, or a Dale operator switched it on (and not off).
 * False until the business has loaded, so nothing asks the server for a part
 * the plan may not include.
 */
export function useCapability(capability: CapabilityId): boolean {
  const business = useBusiness();
  const { features } = useFeatures();
  return business !== undefined && accessTo(capability, business.plan ?? 'base', features).kind === 'open';
}
